import PropTypes from "prop-types";
import * as React from "react";
import ConfirmDialog from "./ConfirmDialog";

const DiscardDialog = ({ open, onConfirm, onCancel }) => (
  <ConfirmDialog
    open={open}
    title="Discard changes?"
    description="Your changes to this product haven't been saved."
    confirmLabel="Discard"
    cancelLabel="Keep editing"
    destructive
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

DiscardDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default DiscardDialog;
